import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

export const indeterminateFirst = keyframes`
  0% {
    left: -100%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
`

export const indeterminateSecond = keyframes`
  0% {
    left: -150%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
`

export const BarLoaderContainer = styled.div<{ isLoading: boolean }>`
  background-color: #B3E5FC;
  display: ${({ isLoading }) => (isLoading ? 'block' : 'none')};
  height: 7px;
  margin-left: -74px;
  overflow: hidden;
  position: fixed;
  width: 100%;
`

export const BarLoader = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
  &:before {
    animation: ${indeterminateFirst} 1.5s infinite ease-out;
    background-color: #03A9F4;
    content: '';
    height: 100%;
    position: absolute;
  }
  &:after {
    animation: ${indeterminateSecond} 1.5s infinite ease-in;
    background-color: #4FC3F7;
    content: '';
    height: 100%;
    position: absolute;
  }
`
